var lightTheme = {
    colors: {
        primary: "#219615",
        warning: "purple",
    },
};
export default lightTheme;
